import { useState } from 'react';
import { AppPage } from 'components/app-page/AppPage';
import CheckImport from '@pages/upload-pages/import-salesman/CheckImport';
import UploadFile from '@pages/upload-pages/import-salesman/UploadFile';



export const ImportSalesman = () => {

	const [ allowImport, setAllowImport ] = useState(false);

	return (
		<AppPage
			className='upload-page'
			pageLabel='Nahrávání souborů - Salesman'
		>
			<div className='upload-content'>	
				
				{allowImport === true &&
					<UploadFile uploadReset={() => setAllowImport(false)} />}

				{allowImport === false &&
					<CheckImport allowUpload={() => setAllowImport(true)}/>}

			</div>

		</AppPage>
	)
}

export default ImportSalesman;